import type { Store } from 'vuex';
import { UserRole, ROLE_GROUPS } from '@/constants/roles';
import { Permission, roleHasPermission } from '@/constants/permissions';
import type { UserSessionInStore } from '@/types/user';
import { isUserSessionAuthenticated } from '@/types/user';

function userDataFromStore(store: Store<unknown>): UserSessionInStore {
    return store.getters['user/userData'] as UserSessionInStore;
}

/** Роли текущего пользователя из Vuex (снимок на момент вызова). */
export function getUserRoles(store: Store<unknown>): UserRole[] {
    const d = userDataFromStore(store);
    if (!isUserSessionAuthenticated(d)) {
        return [];
    }
    return (d.groups ?? []) as UserRole[];
}

export function storeHasRole(store: Store<unknown>, role: UserRole): boolean {
    return getUserRoles(store).includes(role);
}

export function storeHasAnyRole(store: Store<unknown>, roles: UserRole[]): boolean {
    const userRoles = getUserRoles(store);
    return roles.some(role => userRoles.includes(role));
}

export function storeHasAllRoles(store: Store<unknown>, roles: UserRole[]): boolean {
    const userRoles = getUserRoles(store);
    return roles.every(role => userRoles.includes(role));
}

export function storeIsInGroup(
    store: Store<unknown>,
    groupName: keyof typeof ROLE_GROUPS
): boolean {
    return ROLE_GROUPS[groupName].some(role => getUserRoles(store).includes(role));
}

export function storeCan(store: Store<unknown>, permission: Permission): boolean {
    return getUserRoles(store).some(role => roleHasPermission(role, permission));
}
